<template>
  <span :class="eventWrapperClasses">
    <strong>{{ evento.name }}</strong>,
    {{ getEventoHorarioFromDateTime(evento.start) }} - {{ getEventoHorarioFromDateTime(evento.end) }}
  </span>
</template>

<style lang="scss" scoped>
.eventWrapper {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
  padding-left: 6px;
}

.eventWrapperHorarioDisponivel {
  @extend .eventWrapper;
}

.horarioDisponivelLight {
  @extend .eventWrapper;
  color: #6e6777;
}

.horarioDisponivelDark {
  @extend .eventWrapper;
  color: #6e6777;
}

.eventWrapperHorarioAgendado {
  @extend .eventWrapper;
}

.horarioAgendadoLight {
  color: rgb(0, 0, 0, 0.6);
}

.horarioAgendadoDark {
  color: white;
}
</style>

<script>
import { computed } from '@vue/composition-api'
import useAppConfig from '@/@core/@app-config/useAppConfig'
import { getTimeStringComApenasHorasEMinutos } from '@/utils/dateTime'

export default {
  props: {
    isCadastroAgendamento: {
      type: Boolean,
      required: true,
    },
    evento: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const { isDark } = useAppConfig()

    const eventWrapperClasses = computed(() => {
      if (props.isCadastroAgendamento) {
        return `
          eventWrapperHorarioDisponivel
          ${isDark.value ? 'horarioDisponivelDark' : 'horarioDisponivelLight'}
        `
      }

      return `
        eventWrapperHorarioAgendado
        ${isDark.value ? 'horarioAgendadoDark' : 'horarioAgendadoLight'}
      `
    })

    function getEventoHorarioFromDateTime(eventoDateTime) {
      return getTimeStringComApenasHorasEMinutos(new Date(eventoDateTime).toLocaleTimeString())
    }

    return {
      eventWrapperClasses,

      getEventoHorarioFromDateTime,
    }
  },
}
</script>
